// import React from "react";

// const KpiCard = ({ rules }) => {
//   return (
//     <div className="kpi-cards">
//       <div className="kpi-card six">
//         <span>Total Rules</span> {rules.totalRules?.score ?? "N/A"}
//       </div>
//       <div className="kpi-card five">
//         <span>Active Rules</span> {rules.activeRules?.score ?? "N/A"}
//       </div>
//       <div className="kpi-card three">
//         <span>Hard Checks</span> {rules.hardChecks?.score ?? "N/A"}
//       </div>
//       <div className="kpi-card two">
//         <span>Business Rules</span> {rules.businessRules?.score ?? "N/A"}
//       </div>
//     </div>
//   );
// };
// Group 3743.png
// export default KpiCard;


import React from "react";
import box from "../../assests/Group 3743.png";
import box1 from "../../assests/GroupBlue.png";
import box2 from "../../assests/GroupGreen.png";
import box3 from "../../assests/GroupPurple.png";


const KpiCard = ({ rules }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 p-6 bg-white">
      {/* Card 1 */}
      <div className="flex items-center justify-between  bg-[rgba(128,198,173,0.10)] rounded-lg shadow px-6 py-6">
        <div>
          <p className="text-4xl font-semibold"> {rules.totalRules?.score ?? "N/A"}</p>
          <p className="text-sm text-[#000] font-normal">Total Rules</p>
        </div>
        <div className="flex items-center justify-center w-[77px] h-[77px]">
          <img src={box2} alt="Total Rules" className="w-full h-full object-contain" />
        </div>
      </div>

      {/* Card 2 */}
      <div className="flex items-center justify-between  bg-[rgba(128,198,173,0.10)] rounded-lg shadow px-6 py-6">
        <div>
          <p className="text-4xl font-semibold"> {rules.activeRules?.score ?? "N/A"}</p>
          <p className="text-sm text-[#000] font-normal">Active Rules</p>
        </div>
        <div className="flex items-center justify-center w-[77px] h-[77px]">
          <img src={box} alt="Active Rules" className="w-full h-full object-contain" />
        </div>
      </div>

      {/* Card 3 */}
      <div className="flex items-center justify-between  bg-[rgba(128,198,173,0.10)] rounded-lg shadow px-6 py-6">
        <div>
          <p className="text-4xl font-semibold">{rules.hardChecks?.score ?? "N/A"}</p>
          <p className="text-sm text-[#000 font-normal">Hard Checks</p>
        </div>
        <div className="flex items-center justify-center w-[77px] h-[77px]">
          <img src={box1} alt="Hard Checks" className="w-full h-full object-contain" />
        </div>
      </div>

      {/* Card 4 */}
      <div className="flex items-center justify-between  bg-[rgba(128,198,173,0.10)] rounded-lg shadow px-6 py-6">
        <div>
          <p className="text-4xl font-semibold">{rules.businessRules?.score ?? "N/A"}</p>
          <p className="text-sm text-[#000] font-normal ">Business Rules</p>
        </div>
        <div className="flex items-center justify-center w-[77px] h-[77px]">
          <img src={box3} alt="Business Rules" className="w-full h-full object-contain" />
        </div>
      </div>
    </div>
  );
};

export default KpiCard;

